export const homeMock = {
  shopName: '雀荘 和',
  shopNameReading: 'なごみ',
  tagline: '東京都心の大人の隠れ家麻雀サロン',
  hero: {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20mahjong%20parlor%20interior%20with%20dark%20wooden%20mahjong%20table%2C%20soft%20warm%20lighting%2C%20traditional%20Japanese%20decor%20elements%2C%20shoji%20screens%2C%20ambient%20atmosphere%2C%20rich%20mahogany%20tones%2C%20green%20felt%20table%20surface%2C%20professional%20photography%2C%20shallow%20depth%20of%20field&width=1400&height=800&seq=1001&orientation=landscape',
  },
  features: {
    title: '和の空間で、\n極上のひとときを。',
    items: [
      {
        title: '本格麻雀卓',
        description: '全卓ジャンク品マット・自動麻雀卓を完備。牌の触感にこだわるプレイヤーにも満足いただける環境です。',
        image: 'https://readdy.ai/api/search-image?query=Close-up%20of%20beautiful%20mahjong%20tiles%20arranged%20on%20green%20felt%20table%2C%20traditional%20Chinese%20characters%2C%20ivory%20and%20bamboo%20texture%2C%20warm%20ambient%20lighting%2C%20Japanese%20interior%20background%20blur%2C%20elegant%20atmosphere%2C%20rich%20wooden%20table%20frame&width=600&height=800&seq=1002&orientation=portrait',
      },
      {
        title: '完全個室',
        description: '全6室が完全個室仕様。他のお客様を気にせず、ご友人・同僚とゆったりと対局をお楽しみいただけます。',
        image: 'https://readdy.ai/api/search-image?query=Luxurious%20Japanese%20traditional%20private%20room%20with%20tatami%20flooring%2C%20low%20wooden%20table%2C%20shoji%20paper%20screens%2C%20warm%20lantern%20lighting%2C%20zen%20garden%20view%2C%20elegant%20interior%20design%2C%20sophisticated%20atmosphere%2C%20earth%20tones&width=600&height=800&seq=1003&orientation=portrait',
      },
      {
        title: 'お食事・お飲み物',
        description: '和食・洋食の軽食から、お酒・ソフトドリンクまで幅広くご用意。飲み放題コースもございます。',
        image: 'https://readdy.ai/api/search-image?query=Japanese%20tea%20and%20traditional%20snacks%20served%20on%20elegant%20wooden%20tray%2C%20wagashi%20sweets%2C%20matcha%20green%20tea%2C%20ceramic%20cups%2C%20minimalist%20presentation%2C%20warm%20natural%20lighting%2C%20zen%20aesthetic%2C%20refined%20dining%20atmosphere&width=600&height=800&seq=1004&orientation=portrait',
      },
    ],
  },
  about: {
    title: '都会のオアシス、\n和の空間で麻雀を楽しむ。',
    description: '「和」は、東京都心に佇む大人のための隠れ家雀荘です。\n厳選された食材を使ったお食事、こだわりのお飲み物、そして極上の麻雀環境。\n大切な方との時間を、もっと特別なものに。',
    stats: [
      { value: '6', label: '完全個室' },
      { value: '10', label: '年の実績' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20mahjong%20parlor%20exterior%20with%20wooden%20sliding%20doors%2C%20warm%20lantern%20sign%2C%20bamboo%20elements%2C%20night%20atmosphere%20with%20soft%20glowing%20lights%2C%20traditional%20Japanese%20architecture%2C%20welcoming%20entrance%2C%20cherry%20blossom%20tree%20nearby&width=700&height=600&seq=1005&orientation=landscape',
    label: '雀荘 和',
  },
  pricing: {
    subtitle: 'PRICE PLAN',
    title: 'お好みに合わせた\nコースをご用意。',
    courses: [
      {
        name: 'はじめてコース',
        price: '3,500',
        unit: '円/時間',
        description: '初心者向け・レクチャー付き',
        image: 'https://readdy.ai/api/search-image?query=Minimalist%20Japanese%20mahjong%20table%20setup%20for%20beginners%2C%20clean%20modern%20interior%2C%20soft%20natural%20lighting%2C%20warm%20beige%20tones%2C%20simple%20elegant%20arrangement%2C%20welcoming%20atmosphere%20for%20new%20players&width=400&height=500&seq=1006&orientation=portrait',
        bgColor: 'bg-[#E8DDD4]',
        features: ['ルール解説付き', '飲み物1杯付', '4名様まで'],
      },
      {
        name: 'スタンダードコース',
        price: '5,000',
        unit: '円/時間',
        description: '飲み放題付き・お気軽プラン',
        image: 'https://readdy.ai/api/search-image?query=Premium%20mahjong%20private%20room%20with%20luxurious%20wooden%20interior%2C%20leather%20seating%2C%20atmospheric%20lighting%2C%20high-end%20Japanese%20decor%2C%20sophisticated%20gaming%20space%2C%20warm%20amber%20tones&width=400&height=500&seq=1007&orientation=portrait',
        bgColor: 'bg-[#D4E4D4]',
        features: ['飲み放題', 'おつまみ3品', '4名様まで'],
      },
      {
        name: 'VIPコース',
        price: '8,000',
        unit: '円/時間',
        description: '特別室・フルサービス',
        image: 'https://readdy.ai/api/search-image?query=VIP%20Japanese%20mahjong%20suite%20with%20elegant%20furnishings%2C%20panoramic%20city%20view%20through%20large%20windows%2C%20modern%20traditional%20fusion%20design%2C%20champagne%20and%20luxury%20service%2C%20golden%20ambient%20lighting&width=400&height=500&seq=1008&orientation=portrait',
        bgColor: 'bg-[#E4DED4]',
        features: ['特別室利用', '飲食フルサービス', '6名様まで'],
      },
      {
        name: '団体コース',
        price: '15,000',
        unit: '円/時間',
        description: '貸切・イベント対応',
        image: 'https://readdy.ai/api/search-image?query=Group%20mahjong%20party%20room%20with%20multiple%20tables%2C%20festive%20atmosphere%2C%20traditional%20Japanese%20decorations%2C%20warm%20communal%20lighting%2C%20spacious%20layout%2C%20red%20and%20gold%20accent%20colors%2C%20celebratory%20mood&width=400&height=500&seq=1009&orientation=portrait',
        bgColor: 'bg-[#E8D4C8]',
        features: ['貸切利用', '2卓利用可', '20名様まで'],
      },
    ],
  },
  access: {
    title: '心ゆくまで、\n牌を楽しむひとときを。',
    subtitle: '東京都心からアクセス便利。駅徒歩3分の隠れ家空間でお待ちしております。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20street%20view%20at%20dusk%20with%20traditional%20storefronts%2C%20warm%20street%20lanterns%2C%20cozy%20neighborhood%20atmosphere%2C%20soft%20evening%20light%2C%20inviting%20pedestrian%20street%2C%20traditional%20wooden%20buildings&width=1200&height=400&seq=1013&orientation=landscape',
    address: '東京都新宿区歌舞伎町1-2-3 和ビル 4F',
    phone: '03-1234-5678',
    contacts: {
      phone: { label: '電話', value: '03-1234-5678', href: 'tel:0312345678' },
      line: { label: 'LINE', value: '@nagomi-mahjong', href: 'https://line.me/R/ti/p/@nagomi-mahjong' },
      instagram: { label: 'Instagram', value: '@nagomi_mahjong', href: 'https://instagram.com/nagomi_mahjong' },
    },
    hours: [
      { day: '月〜金', time: '14:00〜翌5:00' },
      { day: '土日・祝日', time: '12:00〜翌5:00' },
    ],
  },
  footer: {
    description: '東京都心の大人の隠れ家麻雀サロン。\n和の空間で、極上のひとときをお過ごしください。',
    links: [
      { label: 'ホーム', href: '#' },
      { label: 'コース', href: '#pricing' },
      { label: 'アクセス', href: '#access' },
    ],
    sns: [
      { icon: 'ri-phone-line', href: 'tel:0312345678', label: '電話' },
      { icon: 'ri-line-line', href: 'https://line.me/R/ti/p/@nagomi-mahjong', label: 'LINE' },
      { icon: 'ri-instagram-line', href: 'https://instagram.com/nagomi_mahjong', label: 'Instagram' },
    ],
    copyright: '© 2026 雀荘 和 All Rights Reserved.',
  },
  navbar: {
    links: [
      { label: '特徴', href: '#features' },
      { label: 'コース', href: '#pricing' },
      { label: 'アクセス', href: '#access' },
    ],
  },
};